export default __webpack_public_path__ + "static/go4sledge-logo-86307944095535005c8f606308db1796.gif";